import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Country } from '../models';

@Injectable()
export class RestCountriesService {

  private apiBaseUrl = 'https://restcountries.com/v3';

  constructor(
    private http: HttpClient,
  ) {}

  get(path: string, params: HttpParams = new HttpParams()): Observable<Country> {
    return this.http.get(`${this.apiBaseUrl}/${path}`, { params })
      .pipe(
        catchError((error) => throwError(error)),
        map((data) => data as Country),
      );
  }

  getAll(): Observable<any> {
    return this.http.get(`${this.apiBaseUrl}/all`)
      .pipe(catchError((error) => throwError(error)),
      );
  }
}
